import { PATHS_BY_ENV } from '@constant/paths';
import { env } from '@helpers/EnvHelper';
import { Grid, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	wrapGrid: {
		flexWrap: 'nowrap',
		overflowX: 'auto',
		WebkitOverflowScrolling: 'touch',
		scrollbarWidth: 'none',
		'&::-webkit-scrollbar': {
			display: 'none'
		},
		whiteSpace: 'nowrap',
		padding: '16px 0',
		[theme.breakpoints.down('md')]: {
			padding: '5rem 0 16px'
		}
	},
	link: {
		color: 'black',
		'&:hover': {
			textDecoration: 'underline'
		}
	}
}));

export const ToolsNavigation = () => {
	const { classes } = useStyles();
	const { t } = useTranslation();

	return (
		<>
			<Grid container columnGap={3} alignItems="center" className={classes.wrapGrid}>
				<Grid item>
					<Typography variant="h4">{t('TOOLS')}</Typography>
				</Grid>
				<Grid item>
					<Link href="/" className={classes.link} fontWeight="bold">
						<Typography variant="body2" fontWeight="bold">
							{t('TRANSFER_TRACKING')}
						</Typography>
					</Link>
				</Grid>
				<Grid item>
					<Link href={PATHS_BY_ENV[env].BEFTNLink} target="_blank" className={classes.link}>
						<Typography variant="body2" fontWeight="bold">
							{t('BDT_ROUTING_NUM')}
						</Typography>
					</Link>
				</Grid>
				<Grid item>
					<Link href={PATHS_BY_ENV[env].IFSCLink} target="_blank" className={classes.link}>
						<Typography variant="body2" fontWeight="bold">
							{t('IFSC')}
						</Typography>
					</Link>
				</Grid>
			</Grid>
		</>
	);
};
